import styled from "styled-components";
import { breakpoints } from "../constants/breakpoints";
import { Container } from "styles/common/container";

export const PrivacyPolicyPageTitleWrapper = styled.div`
  background: ${({ theme }) => theme.colors.brand[500]};
  padding: 50px 0;

  @media ${breakpoints.tablet} {
    padding: 100px 0;
  }
`;

export const PrivacyPolicyPageTitle = styled.h1`
  color: ${({ theme }) => theme.colors.white};
  margin: 0;
  font-size: ${({ theme }) => theme.fontSizes["4xl"]};
  text-align: center;

  @media ${breakpoints.tablet} {
    font-size: ${({ theme }) => theme.fontSizes["5xl"]};
    text-align: left;
  }
`;

export const PrivacyPolicyContentContainer = styled(Container)`
  margin: 50px auto;

  @media ${breakpoints.tablet} {
    margin: 80px auto;
  }
`;

export const PrivacyPolicyLanguage = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 50px;

  @media ${breakpoints.tablet} {
    margin-bottom: 80px;
  }
`;

export const PrivacyPolicyLanguageItem = styled.a`
  padding: 0 10px;
  text-decoration: none;
  font-weight: bold;
  color: ${({ theme }) => theme.colors.brand[500]};
`;

export const PrivacyPolicyContent = styled.div`
  line-height: 1.5;

  li {
    margin-bottom: 5px;
  }
`;

export const RefundPolicyHeaderContainer = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
`;
